<template>
    <div class="clock-app settings">
        <div class="mt-3">
                <label class="block text-xs font-semibold text-gray-700 uppercase tracking-widest mb-2 text-left">
                    Select Calendar Type
                </label>
                <select @change="onChange($event)" name="cType" :value="type" type="text" class="form-control ">

                    <option value="half">Date</option>
                    <option value="full">Full Calendar</option>
                   

                </select>
        </div>
        <div  v-if="type === 'full'" class="mt-3">
            <label class="block text-xs font-semibold text-gray-700 uppercase tracking-widest mb-2 text-left">
                Languages
            </label>
                <select  name="lang" type="text" @change="onBGChange($event)" class="form-control " :value="lang">

                    <option value="de">German</option>
                    <option value="en">English</option>
                    <option value="tr">Turkish</option>
                    <option value="ar">Arabic</option>
                   
                </select>
        </div> 
        <div  v-if="type === 'full'" class="mt-3">
            <label class="block text-xs font-semibold text-gray-700 uppercase tracking-widest mb-2 text-left">
                Begin Week
            </label>
                <select  name="beginweek" @change="onBGChange($event)" type="text" class="form-control " :value="beginweek">

                    <option value="su">Sunday</option>
                    <option value="mo">Monday</option>
                 
                   
                </select>
        </div> 
        <div v-if="type === 'half'"  class="mt-3">
            <div class="border rounded py-2 px-3">
                <div class="d-flex align-items-center justify-content-between">
                    <label class="block text-xs font-semibold text-gray-700 uppercase tracking-widest mb-0 text-left">
                        Font Color
                    </label>

                    <input type="color" @input="onColorChange($event)" name="color"  class="custonInput" :value="color" /> 
                </div> 
            </div>
        </div> 
        <div v-if="type === 'full'"  class="mt-3">
            <div class="border rounded py-2 px-3">
                <div class="d-flex align-items-center justify-content-between">
                    <label class="block text-xs font-semibold text-gray-700 uppercase tracking-widest mb-0 text-left">
                        Header Font Color
                    </label>

                    <input type="color" @input="onColorChange($event)" name="Hcolor"  class="custonInput" :value="Hcolor" /> 
                </div> 
            </div>
        </div> 
        <div v-if="type === 'full'"  class="mt-3">
            <div class="border rounded py-2 px-3">
                <div class="d-flex align-items-center justify-content-between">
                    <label class="block text-xs font-semibold text-gray-700 uppercase tracking-widest mb-0 text-left">
                        Date Font Color
                    </label>

                    <input type="color" @input="onColorChange($event)" name="Dcolor"  class="custonInput" :value="Dcolor" /> 
                </div> 
            </div>
        </div> 
        <div v-if="type === 'full'"  class="mt-3">
            <div class="border rounded py-2 px-3">
                <div class="d-flex align-items-center justify-content-between">
                    <label class="block text-xs font-semibold text-gray-700 uppercase tracking-widest mb-0 text-left">
                        Today Date Color 
                    </label>

                    <input type="color" @input="onColorChange($event)" name="Tcolor"  class="custonInput" :value="Tcolor" /> 
                </div> 
            </div>
        </div> 
        
        <div  v-if="type === 'full'" class="mt-3">
            <div class="border rounded py-2 px-3">
                <div class="d-flex align-items-center justify-content-between">
                    <label class="block text-xs font-semibold text-gray-700 uppercase tracking-widest mb-0 text-left">
                        Background Color
                    </label>

                    <input type="color" @input="onBGChange($event)" name="bgColorL"  class="custonInput" :value="bgColorL" /> 
                    <input type="color" @input="onBGChange($event)" name="bgColorR"  class="custonInput" :value="bgColorR" /> 
                </div> 
            </div>
        </div> 
      
       
        <div v-if="type === 'half'" class="mt-3">
                <label class="block text-xs font-semibold text-gray-700 uppercase tracking-widest mb-2 text-left">
                    Select Date Format
                </label>
                <select @change="onChange($event)"  name="format" type="text" class="form-control " :value="format">

                    <option value="D.M.YYYY">D.M.YYYY</option>
                    <option value="MM/DD/YYYY">MM/DD/YYYY</option>
                    <option value="DD/MM/YYYY">DD/MM/YYYY</option>
                    <option value="YYYY-MM-DD">YYYY-MM-DD</option>
                    <option value="MM/DD/YY">MM/DD/YY</option>
                    <option value="MM-DD-YYYY">MM-DD-YYYY</option>

                </select>
        </div>

       
    </div>
</template>
<script>
export default { 
 name:"CalendarAppSettings",
 components:{
 },
 data(){
    return{
        fullformat:false,
        color:"#000",
        type:"",
        bgColorL:"",
        bgColorR:"",
        Hcolor:"",
        Dcolor:"",
        Tcolor:"",
        format:"",
        lang:'en',
        beginweek:'su'
    }
 },
 computed:{
    getActiveCanvas() {
      return this.$store.getters.getCurrentActiveCanvas
    },
 },
 
 watch:{
    "$store.state.activeObjectprops" : {
            handler(updatedValues) {
              
                this.showSeconds = updatedValues?.showSeconds;
                this.fullformat = updatedValues?.format === "24" ? true : false;
                this.color = updatedValues?.color;
                this.bgColorL = updatedValues?.bgColorL;
                this.bgColorR = updatedValues?.bgColorR;
                this.Hcolor = updatedValues?.Hcolor;
                this.Dcolor = updatedValues?.Dcolor;
                this.Tcolor = updatedValues?.Tcolor;
                this.type = updatedValues?.cType;
                this.format = updatedValues?.format;
                this.lang = updatedValues?.lang;
                this.beginweek = updatedValues?.beginweek;
            },
            deep: true,
            immediate: true

        },
    fullformat(value){
        console.log("fullformate:" + value);
        this.changeFormat(value)
    },
    showSeconds(value){
        console.log("showSeconds:" + value);
        this.changeShowSeconds(value)
    }
 },
 methods:{
    getTimeZone(value){
        this.$store.dispatch("setCurrentObjectProperties", {  timezone: value.timezone ? value.timezone : "" });
       
    },
    changeFormat(value){
        this.$store.dispatch("setCurrentObjectProperties", { format: value == true  ? "24" : "12" });
    },
    changeShowSeconds(value){
        this.$store.dispatch("setCurrentObjectProperties", { showSeconds: value });
    },
    onColorChange(e){
            this.$store.dispatch("setCurrentObjectProperties" , { [e.target.name]:  e.target.value })
        },
    onBGChange(e){
            this.$store.dispatch("setCurrentObjectProperties" , { [e.target.name]:  e.target.value })
        },
    
        onChange(e){
            debugger // eslint-disable-line no-debugger
            if(e.target.value === "full"){
                this.$store.dispatch("setCurrentObjectProperties" , { [e.target.name]:  e.target.value, height: this.getActiveCanvas.size.height, width: this.getActiveCanvas.size.width })

            } else {

                this.$store.dispatch("setCurrentObjectProperties" , { [e.target.name]:  e.target.value,width:750 , height: "auto" })
            }
        },
       
 }
}
</script>